import {
  CERTIFICATION_DOMAIN,
  CERTIFICATION_DOMAIN_EXPERIENCE_ROLE
} from '../../AppraiserForm/constants/certificationDomain';

const DOMAIN_VALUE_TO_DISPLAYNAME = {
  [CERTIFICATION_DOMAIN.DEV]: 'DEV',
  [CERTIFICATION_DOMAIN.HM]: 'HM',
  [CERTIFICATION_DOMAIN.SVC]: 'SVC',
  [CERTIFICATION_DOMAIN.VRT]: 'VRT',
  [CERTIFICATION_DOMAIN.SAF]: 'SAF',
  [CERTIFICATION_DOMAIN.SEC]: 'SEC',
  [CERTIFICATION_DOMAIN.DATA]: 'DATA',
  [CERTIFICATION_DOMAIN.PPL]: 'PPL',
  [CERTIFICATION_DOMAIN.SPM]: 'SPM'
};

const ROLE_VALUE_TO_DISPLAYNAME = {
  [CERTIFICATION_DOMAIN_EXPERIENCE_ROLE.ATM]: 'ATM',
  [CERTIFICATION_DOMAIN_EXPERIENCE_ROLE.ATL]: 'ATL'
};

export const AppraisersProfileMapper = {
  mapAppraisersDataForEvent: appraisersData =>
    appraisersData?.map(appraiserData => ({
      externalUserId: appraiserData.ExternalUserId,
      state: appraiserData.State,
      country: appraiserData.Country,
      observation: appraiserData.Observation,
      additionalInformation: appraiserData.AdditionalInformation,
      timeZone: appraiserData.TimeZoneDisplayName,
      domainExperienceSummaryList: appraiserData.DomainExperienceSummaryList.map(
        domainExperience => ({
          domain: DOMAIN_VALUE_TO_DISPLAYNAME[domainExperience.Domain],
          highestRole: ROLE_VALUE_TO_DISPLAYNAME[domainExperience.HighestRole],
          totalYearsOfExperience: domainExperience.TotalYearsOfExperience
        })
      ).sort((a, b) => {
        if (a.highestRole === b.highestRole) {
          return a.domain.localeCompare(b.domain);
        }
        return a.highestRole.localeCompare(b.highestRole);
      })
    }))
};
